<template>
<div class="yin-yang-related-chart-group-wrapper" :style="{
  '--related-chart-width': '400px'
}">
  <yin-yang-related-chart-group :site-data="dataList[0]" />
</div>
</template>

<script>
import YinYangRelatedChartGroup from '../../../../components/Data/YinYangRelatedChartGroup'

export default {
  name: 'YinYangRelatedChartGroupWrapper',
  components: {YinYangRelatedChartGroup},
  props: {
    filterSites: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    },
    dataList: {
      required: true,
      type: Array
    }
  }
}
</script>

<style lang="scss">
.yin-yang-related-chart-group-wrapper {
  display: flex;
  justify-content: center;
  --related-chart-header-height: 30px;

  > * {
    width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/YinYangRelatedChartGroupWrapper.vue